import React, { useState } from "react"
import { Navigate, useParams } from "react-router-dom"
import { useToast } from "~/utils/Toast"

import useFetchResource from "~/hooks/useFetchResource"
import getAppConfig from "~/utils/getAppConfig"
import { apiCategories } from "~/routes"

import PageContainer from "~/library/PageContainer"
import CategoryForm from "~/components/CategoryForm"
import LoadingWrapper from "~/library/LoadingWrapper"
import Category from "~/types/Category"

const EditCategory = () => {
  const [isCategoryUpdated, setIsCategoryUpdated] = useState<boolean>(false)

  const { id } = useParams<{ id: string }>()
  const { venueSlug } = getAppConfig()
  const toast = useToast()

  const endpoint = apiCategories.show.path({ venueSlug, id: id! })
  const { data: category, isLoading } = useFetchResource<{ category: Category }, "category">(
    endpoint,
    "category",
    {}
  )

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      id: id!,
      category: formValues,
    }

    const req = apiCategories.update({ data })
    req
      .then(() => {
        setIsCategoryUpdated(true)
        toast("Category updated successfully", "success")
      })
      .catch((res) => {
        toast(
          `Error updating category. ${res.body?.errors?.join(", ") || "Please try again"}`,
          "danger"
        )
      })
  }

  if (isCategoryUpdated) {
    return <Navigate to={`/categories/${id}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">Edit Category</h3>
          <LoadingWrapper isLoading={isLoading}>
            <CategoryForm onSubmit={handleSubmit} initialValues={category} isEditing={true} />
          </LoadingWrapper>
        </div>
      </div>
    </PageContainer>
  )
}

export default EditCategory
